import React, { FC, ReactElement } from 'react';

import {
  CombinedMonthlyResultsContainer,
  PollResultKeys
} from 'buyside/components/container/CompanyShow/pollResultsUtil';

import styles from './pollingTableStyles.scss';

const PollingTable: FC<{
  questionName: string;
  lastTwelveMonths: CombinedMonthlyResultsContainer;
  currentMonths: CombinedMonthlyResultsContainer;
}> = ({ questionName, lastTwelveMonths, currentMonths }): ReactElement => {
  return (
    <div>
      <table className={styles.resultTable}>
        <thead>
          <tr>
            <th rowSpan={2}>{questionName.split(' ')[1]}</th>
            <th colSpan={2}>LTM</th>
            <th colSpan={2}>Current Month</th>
          </tr>
          <tr>
            <th>{PollResultKeys.buyside}</th>
            <th>{PollResultKeys.retail}</th>
            <th>{PollResultKeys.buyside}</th>
            <th>{PollResultKeys.retail}</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(lastTwelveMonths).map(
            (answerOption): ReactElement => {
              const currentTwelveMonth = lastTwelveMonths[answerOption];
              const currentMonth = currentMonths[answerOption];
              return (
                <tr key={answerOption}>
                  <td>{answerOption}</td>
                  <td>{currentTwelveMonth[PollResultKeys.buyside] || 0}%</td>
                  <td>{currentTwelveMonth[PollResultKeys.retail] || 0}%</td>
                  <td>{currentMonth[PollResultKeys.buyside] || 0}%</td>
                  <td>{currentMonth[PollResultKeys.retail] || 0}%</td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PollingTable;
